var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sso-error"},[_c('div',{staticClass:"sso-error-message"},[_vm._v(_vm._s(_vm.message))]),(_vm.showSupport)?_c('div',{staticClass:"sso-error-support"},[_vm._v(" Sorun devam ederse "),_c('a',{attrs:{"href":"mailto:destek@uesturkiye.com"}},[_vm._v("destek@uesturkiye.com")]),_vm._v(" adresinden bize ulaşabilirsiniz. ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }